;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection = APP.module('Collection');
	var Model      = APP.module('Model');

	Collection.Leagues =  Backbone.Collection.extend({
		model: Model.League,
		api_prefix: '',
		//url: function() {
		//	return this.api_prefix + this.methodUrl;
		//},
		isNew: function() {
			return true;
		},

		setCommissioner: function(user_id) {
			this.each(function(league) {
				//user can be a commissioner if original commissioner have added current ability
				league.set('is_commissioner', (league.get('commissioner') == user_id || league.get('user_status') == 'commissioner'));

				//specify league creator
				league.set('is_original_commissioner', league.get('commissioner') == user_id ? user_id : false);
			});

			return this;
		},

		setIsFull: function() {

			this.each(function(league) {
				league.set('is_full', (_.isUndefined(league.get('type')) || league.get('type') == 'head_to_head') ?
				league.get('num_teams') == league.get('size') : false);
			});

			return this;
		},

		setLeaguesFinal: function(){

			this.each(function(league) {
				league.setFinal(this.finals_type);
			}, this);

			return this;
		},

		setStatus: function() {
			var now = new Date().getTime();

			this.each(function(league) {
				//TODO: remove 'fail' status checks for FGP
				//var league_type = league.get('type');

				//if (league_type && league_type != 'open' ) {
					if(league.get('draft_status') == 'scheduled' && new Date(league.get('draft_start')).getTime() <= now) {
						league.set('draft_status', 'fail');
					}
					if(league.get('status') == 'scheduled' && new Date(league.get('start_at')).getTime() <= now) {
						league.set('status', 'fail');
					}
				//}
				league.set('is_full', (_.isUndefined(league.get('type')) || league.get('type') == 'head_to_head') ?
				league.get('num_teams') == league.get('size') : false);
			});

			return this;
		},

		setDecimals: function(decimal){

			this.each(function(league) {

				var avg_score = league.get('avg_score');

				if (_.isNumber(avg_score) && avg_score % 1 != 0) {
					avg_score = Math.round10(avg_score, (-1 * decimal));
				}

				if (avg_score) {
					league.set('avg_score', avg_score);
				}

			});

			return this;
		},

		byStatus: function(status, is_not) {
			var func = function (league) {
				return league.get('status') == 'scheduled';
			};

			if (is_not) {
				return new Collection.Leagues(this.reject(func));
			}

			return new Collection.Leagues(this.filter(func));
		},

		show_for_join: function() {
			this.setApiUrl('_join/show_for_join');

			return this;
		},

		show_my: function() {
			this.setApiUrl('_league/show_my');

			return this;
		},

		stats_show_my: function() {
			this.setApiUrl('_stats/show_my');

			return this;
		},
		stats_show_my_list: function() {
			this.setApiUrl('_stats/my_list');

			return this;
		},
		show_my_stats: function() {
			this.setApiUrl('_league/show_my_stats');

			return this;
		},

		show_league_rankings: function() {
			this.setApiUrl('_stats/show_league_rankings');

			return this;
		},

		draft_show_my_leagues_stats: function() {
			this.setApiUrl('_stats/show_my_leagues_stats');

			return this;
		},

		weekly_show_my_leagues_stats: function() {
			this.setApiUrl('_stats/show_my_leagues_stats');

			return this;
		},

		racing_show_my_leagues_stats: function() {
			this.setApiUrl('_stats/show_my_leagues_stats');

			return this;
		},

		showLeagueById: function(league_id){

			this.each(function(league){
				league.findAndFetchById(league_id);
			});

			return this;
		},

		leagueTips: function() {
			this.setApiUrl('_league/tips');

			return this;
		},

		setLeaguesAvatars: function(){

			this.each(function(league){
				league.setLeagueAvatarUrl();
			});

			return this;
		},

		setStartAtLeagues: function(rounds) {

			this.each(function(league) {
				//user can be a commissioner if original commissioner have added current ability
				let round_league = league.get('start_round');
				let round = rounds.get(round_league);
				league.set('start_at', round ? round.get('start') : '');
			});

			return this;
		},

		showSendLetter() {
			this.each(function(league) {
				league.set({
					is_show_send_letter: league.get('is_commissioner') && league.get('class') === 'store'
				})
			});

			return this;
		},
		setLeagueLadderLink() {
			this.each(function(league) {
				const {id, region_id, store_id} = league.attributes;
				const ladder_link = `#tipping/leagues/${region_id || id}/ladder/${region_id ? store_id : ''}`
				league.set({
					ladder_link
				})
			});

			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));
